<template>
  <div class="col">
    <server-table
      :count="getCareerStatementsCount"
      :DataItems="careerStatements"
      @Refresh="Refresh"
      @reset="filter = {}"
      :filter="filter"
      :title="'Career Statements'"
      admin_permission="admin_tasks"
      edit_permission="add_tasks"
      @export="exportCareerStatements"
      import_url="career/statements/import"
    >
      <template #columns>
        <el-table-column prop="statement" label="statement"></el-table-column>
        <el-table-column
          prop="classification"
          label="classification"
        ></el-table-column>
        <el-table-column prop="pattern" label="pattern"></el-table-column>

        <el-table-column prop="" label="_">
          <template slot-scope="scope">
            <div class="main_actions">
              <i
                @click="openEditDialog(scope.row)"
                v-tooltip.top-center="'Edit Statement'"
                class="fa fa-edit  actions-icons edit"
              ></i>
              <i
                @click="removeStatement(scope.row.id)"
                v-tooltip.top-center="'Delete Statement'"
                class="fa fa-times actions-icons delete"
              ></i>
            </div>
          </template>
        </el-table-column>
      </template>
      <template #action>
        <div
          style="position:relative"
          @click="showDialog = true"
          wide
          class="text-capitalize"
        >
          <el-icon class="el-icon-plus"></el-icon>
          Add Career Statements
        </div>
      </template>
    </server-table>

    <!-- Start -->
    <el-dialog
      :title="this.type == 1 ? `Add Career statement` : `Edit Career statement`"
      :visible.sync="showDialog"
      width="60%"
      top="4vh"
    >
      <el-form
        :model="statementsData"
        ref="statementsRef"
        :rules="statementsDataRules"
        label-position="top"
      >
        <div class="row">
          <div class="col-md-6">
            <el-form-item label="statement" prop="statement">
              <el-input v-model="statementsData.statement"></el-input>
            </el-form-item>
          </div>
          <div class="col-md-6">
            <el-form-item label="Language" prop="language">
              <el-select v-model="statementsData.language" style="width: 100%">
                <el-option
                  v-for="item in getCareerStatementsLanguages"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="col-md-6">
            <el-form-item label="question" prop="question_id">
              <el-select
                v-model="statementsData.question_id"
                style="width: 100%"
              >
                <el-option
                  v-for="item in getCareerStatementsQuestions"
                  :key="item.id"
                  :label="item.question"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="col-md-6">
            <el-form-item label="pattern" prop="pattern">
              <el-select v-model="statementsData.pattern" style="width: 100%">
                <el-option
                  v-for="(item, index) in patterns"
                  :key="index"
                  :label="item.label"
                  :value="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="col-md-6">
            <el-form-item label="classification" prop="classification">
              <el-select
                v-model="statementsData.classification"
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in classifications"
                  :key="index"
                  :label="item.label"
                  :value="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
        <div
          class="
                  dialog-footer
                  dialog_footer
                "
        >
          <el-button
            class="text-center text-capitalize save_button delete_button"
            @click="showDialog = false"
          >
            {{ localization("Cancel") }}
          </el-button>
          <el-button
            type=""
            class="
                    text-center
                    text-capitalize
                    save_button
                  "
            @click="saveCareerStatementsQuestions"
          >
            Save
          </el-button>
        </div>
      </el-form>
    </el-dialog>
    <!-- End -->
  </div>
</template>

<script>
import ServerTable from "../../components/DataTablePagination.vue";
import "element-ui/lib/theme-chalk/display.css";
import Swal from "sweetalert2";
export default {
  data() {
    return {
      filter: {},
      showDialog: false,
      type: 1,
      statementsQuestionsId: null,
      statementsData: {
        statement: null,
        question_id: null,
        language: null,
        pattern: null,
        classification: null
      },
      
      patterns: [
        { label: "Confluence" },
        { label: "Precision" },
        { label: "Sequence" },
        { label: "Technical Reasoning" }
      ],
      classifications: [
        { label: "Use First" },
        { label: "As Needed" },
        { label: "Avoid" }
      ]
    };
  },
  mounted() {
    this.Refresh();
  },
  methods: {
    Refresh(query) {
      this.$store.dispatch("user/handlerCareerStatements", {
        query: query
      });
    },
    removeStatement(id) {
      Swal.fire({
        title: "",
        text: `${this.localization("Are You Sure")}`,
        type: "warning",
        icon: "error",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success ",
        cancelButtonClass: "btn btn-danger ",
        confirmButtonText: `${this.localization("Delete")}`,
        cancelButtonText: `${this.localization("Cancel")}`,
        buttonsStyling: false
      }).then(date => {
        if (date.isConfirmed) {
          this.$store
            .dispatch("user/handleDeleteCareerStatements", id)
            .then(_ => {
              this.Refresh(null);
              Swal.fire({
                title: "",
                icon: "success",
                type: "success",
                text: `${this.localization("Deleted")}`,
                confirmButtonText: `${this.localization("Ok")}`,
                confirmButtonClass: "btn btn-success ",
                buttonsStyling: false
              });
            });
        }
      });
    },
    openDialog() {
      this.showDialog = true;
    },
    saveCareerStatementsQuestions() {
      this.$refs["statementsRef"].validate(valid => {
        if (valid) {
          if (this.type == 1) {
            this.$store
              .dispatch("user/handleAddrCareerStatements", {
                query: this.statementsData
              })
              .then(_ => {
                this.showDialog = false;
                this.Refresh();
                this.statementsData.statement = null;
                this.statementsData.language = null;
                this.statementsData.question_id = null;
                this.statementsData.language = null;
                this.statementsData.pattern = null;
                this.statementsData.classification = null;
                Swal.fire({
                  title: "",
                  icon: "success",
                  text: `${this.localization("Done")}`,
                  confirmButtonText: `${this.localization("Ok")}`,
                  type: "success",
                  confirmButtonClass: "btn btn-success ",
                  buttonsStyling: false
                });
              });
          } else {
            this.$store
              .dispatch("user/handleUpdateCareerStatements", {
                id: this.statementsQuestionsId,
                query: this.statementsData
              })
              .then(_ => {
                this.showDialog = false;
                this.Refresh();
                this.statementsData.statement = null;
                this.statementsData.language = null;
                this.statementsData.question_id = null;
                this.statementsData.language = null;
                this.statementsData.pattern = null;
                this.statementsData.classification = null;
                this.statementsQuestionsId = null;
                Swal.fire({
                  title: "",
                  icon: "success",
                  text: `${this.localization("Done")}`,
                  confirmButtonText: `${this.localization("Ok")}`,
                  type: "success",
                  confirmButtonClass: "btn btn-success ",
                  buttonsStyling: false
                });
              });
          }
        }
      });
    },
    openEditDialog(item) {
      this.showDialog = true;
      this.type = 2;
      this.statementsData.statement = item.statement;
      this.statementsData.language = item.language;
      this.statementsData.question_id = item.question_id;
      this.statementsData.pattern = item.pattern;
      this.statementsData.classification = item.classification;
      this.statementsQuestionsId = item.id;
    },
    exportCareerStatements(query) {
      this.$store.dispatch("user/handlerExportCareerStatements", {
        query: query
      });
    }
  },
  computed: {
    careerStatements() {
      return this.$store.getters["user/getCareerStatements"];
    },
    statementsDataRules() {
      return {

        statement: [
          {
            required: true,
            message: this.localization("Please this field is required"),
            trigger: "blur"
          }
        ],
        language: [
          {
            required: true,
            message: this.localization("Please this field is required"),
            trigger: "blur"
          }
        ],
        question_id: [
          {
            required: true,
            message: this.localization("Please this field is required"),
            trigger: "blur"
          }
        ],
        pattern: [
          {
            required: true,
            message: this.localization("Please this field is required"),
            trigger: "blur"
          }
        ],
        classification: [
          {
            required: true,
            message: this.localization("Please this field is required"),
            trigger: "blur"
          }
        ]
      }
    },
    getCareerStatementsCount() {
      return this.$store.getters["user/getCareerStatementsCount"];
    },
    getCareerStatementsQuestions() {
      return this.$store.getters["user/getCareerStatementsQuestions"];
    },
    getCareerStatementsLanguages() {
      return this.$store.getters["user/getCareerStatementsLanguages"];
    }
  },
  components: {
    ServerTable
  }
};
</script>

<style lang="scss" scoped>
.main_actions {
  display: flex;
  padding: 5px 0;
  gap: 10px;
  .actions-icons {
    font-size: 14px;
    width: 30px;
    height: 30px;
    box-shadow: 0 0 6px 0 rgba(#000, 0.2), 0 0 5px -2px rgba(#000, 0.1);
    text-align: center;
    line-height: 30px;
    border-radius: 50%;
    cursor: pointer;
    color: #777;
    transition: 0.3s;
    &.team_count {
      background-color: #11bfe3;
      color: #fff;
    }
    &.add {
      &:hover {
        background-color: #11bfe3;
        color: #fff;
      }
    }
    &.edit {
      &:hover {
        background-color: #ffa534;
        color: #fff;
      }
    }
    &.reinvite {
      &:hover {
        background-color: #3c3;
        color: #fff;
      }
    }
    &.delete {
      &:hover {
        background-color: #fb404b;
        color: #fff;
      }
    }
  }
}
.dialog_footer {
  display: flex;
  justify-content: end;
  align-items: center;

  @media (min-width: 320px) and (max-width: 991px) {
    justify-content: center;
  }
  .save_button {
    // background-color: #23ccef;
    border-color: #00563f;
    background-color: #00563f;
    min-width: 150px;
    color: #fff;
    @media (min-width: 320px) and (max-width: 767px) {
      min-width: 124px;
    }
    &.delete_button {
      background-color: #f56c6c;
      border-color: #f56c6c;
    }
  }
}
</style>
